import noUiSlider from "nouislider";
import Collection from './generic/collection'
import { bubble } from '../js/utils/bubble'
import { debounce } from '../js/utils/debounce'
import { getCfg } from './utils/getCfg'

class RangeSlider {
    sliderValues = {
      "min": 0,
      "max": 10000
    }

    inputDirection = {
      min: 'min',
      max: 'max',
    }

  formatOptionsNames = {
    round: "round",
    noFormat: "noFormat",
  }

    formatOptions = {
      [this.formatOptionsNames.round]: {
        from: function (formattedValue) {
          return Number(formattedValue);
        },
        to: function (numericValue) {
          return Math.round(numericValue);
        }
      },
      [this.formatOptionsNames.noFormat]: {
        from: function (formattedValue) { return formattedValue; },
        to: function (numericValue) { return numericValue; },
      }
    }

    defaultCfg = {
      start: [ 0, 3000 ],
      connect: true,
      range: this.sliderValues,
      margin: 1000,
      step: 1000,
      format: {
        ...this.formatOptions.default
      },
      formatOptionsName: this.formatOptionsNames.round
    }

    constructor(instance) {
      this.instance = instance;
      const dataValue = this.instance.dataset.jsRangeslider;
      this.cfg = getCfg(this.instance, RangeSliderCollection.selectors.instanceCfg, this.defaultCfg)
      this.inputs = document.querySelectorAll(`[data-js-rangeslider-input=${ dataValue }]`)
      this.init();
    }

    createSlider() {
      const formatOptions = this.formatOptions[this.cfg.formatOptionsName]
      this.noUiSlider = noUiSlider.create(this.instance, {
        ...this.cfg,
        format: {
          ...!!formatOptions ? formatOptions : this.formatOptions[this.defaultCfg.formatOptionsName]
        }
      });
    }

    updateSliderValue = ([ minValue, maxValue ]) => {
      this.inputs[0].value = new Intl.NumberFormat().format(minValue);
      this.inputs[1].value = new Intl.NumberFormat().format(maxValue);
    }

    handleReset = (e) => {
      this.instance.noUiSlider.set(this.cfg.start)
    }

    onInputChange = (evt) => {
      const inputDirection = evt.target.dataset.jsRangesliderDir;
      const value = evt.target.value.replace(' ', '');

      if (inputDirection === this.inputDirection.max) {
        this.instance.noUiSlider.set([ null, value ])
      } else {
        this.instance.noUiSlider.set([ value, null ])
      }
    }

    init() {
      this.createSlider();
      this.bindEvents();
    }

    bindEvents() {
      const debouncedBubble = debounce(() => bubble(document, RangeSliderCollection.bubbles.change, this.instance), 500);

      this.instance.noUiSlider.on("update", this.updateSliderValue)
      this.instance.noUiSlider.on("end", () => debouncedBubble());
      this.instance.addEventListener(RangeSliderCollection.bubbles.reset, (e) => this.handleReset(e))

      this.inputs.forEach((input) => {
        input.addEventListener("change", (e) => this.onInputChange(e))
      })
    }
}

export class RangeSliderCollection extends Collection {
    static selectors = {
      instance: "[data-js-rangeslider]",
      instanceCfg: "[data-js-rangeslider-cfg]",
    }

    static bubbles = {
      change: "rangeSlider::change",
      reset: "rangeSlider::reset",
    }
    constructor() {
      super(RangeSliderCollection.selectors.instance, RangeSlider)
      this.init();
    }

    init(context = document) {
      context.querySelectorAll(RangeSliderCollection.selectors.instance).forEach(el => {
        this.collection = new RangeSlider(el)
      })
    }
}
